import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withBannerConfiguration from "../../core/components/banner/configuration/withBannerConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import { actions as layoutsActions } from "../../core/reducers/layoutsStateReducer";
import PIXI from "pixi.js";
import { isMobile } from "react-device-detect";
import { actions as basegameActions } from "../../core/reducers/baseGameReducer";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { actions as freegameActions } from "../../core/reducers/freeGameReducer";
import { actions as flowManagerAction } from "../../core/reducers/flowManagerReducer";
import { actions as multiplierActions } from "../../gamereducer/multiplierReducer";
import { actions as reelgridAction } from "../../core/reducers/reelgridStateReducer";
import { actions as behaviorActions } from "../../gamereducer/behaviourReducer";
import { CURRENCY, TIMER } from "../../core/utills";
import { actions as keyboardListenerActions } from "../../core/reducers/keyboardListenerReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { configGame, constant } from "../../data/config";

interface IProps {
    [x: string]: any;
}

interface IStore {
    [x: string]: any;
}

interface IStateToProps {

    [x: string]: any;

}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class GameBanner extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected scope: any;
    protected gameBannerContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;
    protected objName: any;
    protected introBgGraphic: any;
    protected introBgBlastAnim: any;
    protected hitAreaGraphic: any;
    private outroHitAreaGraphic: any
    protected constantT1: number = 100;
    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.gameBannerContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
            this.objName = "_mobile";
        } else {
            this.ui_mode = "desktop";
            this.objName = "_desktop";
        }

        this.displayUI = this.props.child.filter(this.checkUiMode.bind(this));

    }

    //while first rendering, this method will check the mode first
    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    //this method will call when layout changes
    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }
    correctCurrencyCodeXAF(amount: string) {
        if ((window as any).GAME_INFO.currency == "XAF") {
            return amount.replace('F', 'FCFA');
        }
        if ((window as any).GAME_INFO.currency == "XOF") {
            return amount.replace('F', 'XOF');
        }
        return amount;
    }

    changeGraphicSize() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("introGraphic").width = configGame.CANVAS_HEIGHT;
            UIManager.getRef("introGraphic").height = configGame.CANVAS_WIDTH;
            if (UIManager.getRef("introGraphic").visible === true) {
                UIManager.getRef("introGraphic").width = configGame.CANVAS_HEIGHT;
                UIManager.getRef("introGraphic").height = configGame.CANVAS_WIDTH;
            }
            // if (UIManager.getRef("introGlowImage_mobile")) {
            //     UIManager.getRef("introGlowImage_mobile").scale.x = 0.8;
            //     UIManager.getRef("introGlowImage_mobile").scale.y = 0.8;
            // }
            UIManager.getRef("text_3_OutroScreenFG_mobile") && (UIManager.getRef("text_3_OutroScreenFG_mobile").scale.set(0.7))
            if (UIManager.getRef("text_1_OutroScreenFG_mobile")) {
                UIManager.getRef("text_1_OutroScreenFG_mobile").scale.x = 0.8;
                UIManager.getRef("text_1_OutroScreenFG_mobile").scale.y = 0.8;
            }
        }


        else if (isMobile && window.innerWidth > window.innerHeight) {
            if (UIManager.getRef("introGraphic")) {
                UIManager.getRef("introGraphic").width = configGame.CANVAS_WIDTH;
                UIManager.getRef("introGraphic").height = configGame.CANVAS_HEIGHT;
            }

            //if (UIManager.getRef("introGlowImage_mobile")) {
            //    UIManager.getRef("introGlowImage_mobile").scale.x = 1;
            //    UIManager.getRef("introGlowImage_mobile").scale.y = 1;
            //}

            if (UIManager.getRef("text_1_OutroScreenFG_mobile")) {
                UIManager.getRef("text_1_OutroScreenFG_mobile").scale.x = 1;
                UIManager.getRef("text_1_OutroScreenFG_mobile").scale.y = 1;
            }
        }
    }




    //this method will initialize object in a variable
    initializeVariable() {
        this.introBgGraphic = UIManager.getRef("introGraphic");
        //  this.introBgBlastAnim = UIManager.getRef("blastAnim" + this.objName);

        UIManager.getRef("fg_intro_count_" + this.ui_mode) && (UIManager.setText("fg_intro_count_" + this.ui_mode, (this.props.freegameSpinCountRemaining).toString()));
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.layoutMode !== this.props.layoutMode) {
            this.layoutChange(nextProps.layoutMode);
            // if (this.props.featureJustFinished) {

            this.initializeVariable();

            this.changeGraphicSize();
            // }

            return false;
        }
        if (nextProps.gameBroken !== this.props.gameBroken) {


            return false;
        }
        if (nextProps.soundIsPlaying !== this.props.soundIsPlaying) {


            return false;
        }
        if (!nextProps.isFeatureActive && nextProps.isFeatureActive != this.props.isFeatureActive) {

            nextProps.freegameSpinCountRemaining == 0 && this.showOutro(nextProps);
            return false;
        }
        if (nextProps.callFlowManager) {
            if (nextProps.freegameSpinCountRemaining == 0 && !(nextProps.showWinShower || nextProps.showWinCelebration) && !nextProps.isFeatureActive) {


                this.showOutro(nextProps);

            }

            return false;
        }

        return true;
    }
    showOutro(nextProps: any) {
        let timer = TIMER.TimerManager.createTimer(1000);
        timer.on('end', (e: any) => {

            nextProps.soundIsPlaying && nextProps.playSound([{ name: "fgOutroSound", loop: false, vol: 0.7 }, { name: "fgloop", vol: 0.1 }]);
            nextProps.stopSound([{ name: "bgloop" }]);
            nextProps.stopSound([{ name: "fgloop" }]);
            //this.hitAreaActiveOutro(nextProps);
            let win = CURRENCY.CurrencyManager.formatCurrencyString(nextProps.fgSpinWinAmount, true, true, true, true);
            win = this.correctCurrencyCodeXAF(win);
            (UIManager.setText("text_3_OutroScreenFG_" + this.ui_mode, win));
            UIManager.getRef("gameBannerContainerOutro").visible = true;
            this.changeGraphicSize();
            this.props.spaceBarSpin(true);

        });
        timer.start();
    }
    handleEvent = (e: any) => {

    }

    //this method will be called when a button will clicked
    hitAreaActive() {

        this.hitAreaGraphic = UIManager.getRef("introPanelSkipGraphic");
        this.hitAreaGraphic.interactive = true;
        this.hitAreaGraphic.buttonMode = true;
        this.hitAreaGraphic.click = (event: any) => {
            this.hitAreaDeactivate();
            this.setFreeGameData();
            //label_BetPanel_value.visible = false;
        }
        this.hitAreaGraphic.touchend = (event: any) => {
            this.hitAreaDeactivate();
            this.setFreeGameData();
            //label_BetPanel_value.visible = false;
        }

    }
    hitAreaDeactivate() {
        this.hitAreaGraphic.interactive = false;
        this.hitAreaGraphic.buttonMode = false;
    }

    hitAreaActiveOutro(nextProps: any) {
        this.outroHitAreaGraphic = UIManager.getRef("outroPanelSkipGraphic");
        this.outroHitAreaGraphic.interactive = true;
        this.outroHitAreaGraphic.touchend = (event: any) => {
            //this.hitAreaDeactivateOutro();
            // if (!nextProps.inFreeGame) {
            //     return
            // }
            // this.props.setOutroBannerSkip(true);
            // this.props.stopFreegame();
            // //RAJANU set freegame initial reelgrid
            // let reelData = [
            //     [31, 19, 19, 19, 19, 19, 19, 19, 19],
            //     [31, 31, 19, 31, 31, 31, 19, 19, 31],
            //     [1, 1, 1, 1, 1, 1, 1, 1, 1],
            //     [21, 21, 21, 21, 39, 21, 21, 21, 21],
            //     [52, 46, 10, 34, 28, 28, 46, 52, 52],
            //     [14, 56, 2, 44, 14, 14, 44, 44, 56],
            //     [2, 14, 8, 20]
            // ]
            // let FWReelData;
            // FWReelData = {
            //     stopReels: reelData,
            // }

            // this.props.relGridSymbolCountDisplay([3, 3, 3, 5, 6, 4])

            // this.props.updateReelData(FWReelData);
            // this.props.setApplicationToBaseGameState(true);


            // let timer4 = TIMER.TimerManager.createTimer(this.constantT1);
            // timer4.on('end', (e: any, data: any) => {

            //     this.props.setAllButtonEnable();
            //     this.props.nextAutoplay();
            //     this.props.nextFreegame();
            // })
            // timer4.start();

        }
        this.outroHitAreaGraphic.click = (event: any) => {
            //this.hitAreaDeactivateOutro();
            if (!nextProps.inFreeGame) {
                return
            }
            this.props.setOutroBannerSkip(true);
            this.props.stopFreegame();
            //RAJANU set freegame initial reelgrid
            let reelData = [
                [11, 3, 3, 7, 7, 0],
                [4, 4, 0, 8, 9, 2],
                [4, 8, 3, 3, 10, 7],
                [6, 3, 8, 8, 0, 0],
                [9, 1, 1, 3, 7, 7],
                [2, 2, 4, 10, 6, 3]
            ]
            let FWReelData;
            FWReelData = {
                stopReels: reelData,
            }

            this.props.relGridSymbolCountDisplay([3, 3, 3, 5, 6, 4])

            this.props.updateReelData(FWReelData);
            this.props.setApplicationToBaseGameState(true);


            let timer4 = TIMER.TimerManager.createTimer(this.constantT1);
            timer4.on('end', (e: any, data: any) => {

                this.props.setAllButtonEnable();
                this.props.nextAutoplay();
                this.props.nextFreegame();
            })
            timer4.start();

        }

    }
    hitAreaDeactivateOutro() {
        this.outroHitAreaGraphic.interactive = false;
        this.outroHitAreaGraphic.buttonMode = false;
    }


    setFreeGameData() {
        this.hitAreaDeactivate();
        let reelData = [
            [11, 3, 3, 7, 7, 0],
            [4, 4, 0, 8, 9, 2],
            [4, 8, 3, 3, 10, 7],
            [6, 3, 8, 8, 0, 0],
            [9, 1, 1, 3, 7, 7],
            [2, 2, 4, 10, 6, 3]
        ]
        let FWReelData;
        FWReelData = {
            stopReels: reelData,
        }
        this.props.relGridSymbolCountDisplay([3, 3, 3, 5, 6, 4])
        this.props.updateReelData(FWReelData);

        this.props.stopSound([{ name: "introLoop" }]);


        this.props.setApplicationToBaseGameState(false);
        this.displayUI.map((data: any) => {
            UIManager.getRef(data.name).visible = false;
        })

        UIManager.getRef("introGraphic").visible = false;
        this.props.flowManagerCalled(false);
        this.props.setIntroDone();
        this.props.activeMultiplier(true);
        this.props.setMultiplierValue(this.props.storeMultiplierCurrentValue);
        this.props.startFreegame();
        this.props.nextFreegame();


    }



    componentDidMount() {

        if (this.props.group === "Outro") {
            this.changeGraphicSize();
        }
        if (this.props.group === "Intro") {
            this.props.spaceBarSpin(false);
            this.layoutChange(this.props.layoutMode);
            this.setLayout();
            this.hitAreaActive();
            let buyText = UIManager.getRef("fg_intro_you_" + this.ui_mode);
            buyText && (buyText.visible = true);
            //   if (localStorage.getItem("selection_local") != "-1") {
            if (constant.configGame.selection_local != "-1") {

                // let buyText = UIManager.getRef("fg_intro_lockedReel");
                // buyText && (buyText.visible = true);
                buyText.text = this.props.langObj["buyFeature"];
            } else {
                buyText.text = this.props.langObj["youve"];
            }
            if (!this.props.clickToEnterFeature && !this.props.gameBroken) {
                let timer = TIMER.TimerManager.createTimer(3000);
                timer.on('end', (e: any) => {
                    if (this.hitAreaGraphic.interactive) {
                        this.setFreeGameData();
                    }

                });
                timer.start();
            }


        }

    }

    setLayout() {
        this.initializeVariable();
        this.layoutChange(this.props.layoutMode);
        UIManager.getRef("text_IntroScreenFG_desktop") && (UIManager.getRef("text_IntroScreenFG_desktop").text = this.props.freegameSpinCountWin);
        if (isMobile && UIManager.getRef("introGraphic") !== undefined) {

            if (window.innerWidth < window.innerHeight) {
                if (UIManager.getRef("introGraphic").visible === true) {
                    UIManager.getRef("introGraphic").width = configGame.CANVAS_HEIGHT;
                    UIManager.getRef("introGraphic").height = configGame.CANVAS_WIDTH;
                }
                //  if (UIManager.getRef("introGlowImage_mobile")) {
                //      UIManager.getRef("introGlowImage_mobile").scale.x = 0.8;
                //      UIManager.getRef("introGlowImage_mobile").scale.y = 0.8;
                //  }

                if (UIManager.getRef("text_1_OutroScreenFG_mobile")) {
                    UIManager.getRef("text_1_OutroScreenFG_mobile").scale.x = 0.8;
                    UIManager.getRef("text_1_OutroScreenFG_mobile").scale.y = 0.8;
                }

            } else {
                //  if (UIManager.getRef("introGlowImage_mobile")) {
                //      UIManager.getRef("introGlowImage_mobile").scale.x = 1;
                //      UIManager.getRef("introGlowImage_mobile").scale.y = 1;
                //  }

                if (UIManager.getRef("text_1_OutroScreenFG_mobile")) {
                    UIManager.getRef("text_1_OutroScreenFG_mobile").scale.x = 1;
                    UIManager.getRef("text_1_OutroScreenFG_mobile").scale.y = 1;
                }
            }

        }

    }

    renderBlastAnimationBehind() {

    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        /* let win=CURRENCY.CurrencyManager.formatCurrencyString(this.props.totalCreditWinAmount/100, true, true, true, true);
         UIManager.getRef("gameBannerContainer").visible = false;
          if (this.props.featureJustFinished) {
 
             (UIManager.setText("text_3_OutroScreenFG_" + this.ui_mode, win));
 
      }  */
        // if (this.props.featureJustFinished) {
        this.setLayout();
        // this.layoutChange(this.props.layoutMode);
        // this.initializeVariable();
        // if (isMobile && window.innerWidth < window.innerHeight &&  UIManager.getRef("introGraphic").visible === true) {
        //      UIManager.getRef("introGraphic").width = configGame.CANVAS_HEIGHT;
        //      UIManager.getRef("introGraphic").height = configGame.CANVAS_WIDTH;
        // }
        // }
    }
    mouseOver() {

        //alert("mouseOver")
    }
    mouseOut() {
        //alert("mouseOut")

    }
    render() {

        return (
            <UIManager id={"gameBannerContainer"} name={"gameBannerContainer"} type={"Container"}
                ref={i => this.gameBannerContainer = i}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} ClickHandler={this.handleEvent} mouseOver={this.mouseOver} mouseOut={this.mouseOut}
                            scope={this}
                            langObj={this.props.langObj} type={i.type} group={this.props.group} app={this.app}
                            configGame={configGame}
                            id={i.id} {...i} />)
                }
            </UIManager>)
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'randomWildsState' | 'gridsState' | 'asyncInitAction' | 'wrapperState' | 'soundState' | 'freegameState' | 'winCelebrationState' | 'winShowerState' | 'basegameState' | 'applicationState' | 'gameactionstate' | 'MultiplierState' | 'behaviourState' | 'reelgridState' | 'flowManagerState'>): IStateToProps =>
    ({
        gameBroken: state.asyncInitAction.gameBroken,
        soundIsPlaying: state.soundState.soundIsPlaying,
        layoutMode: state.applicationState.layoutMode,
        wins: state.basegameState.wins,
        featureJustFinished: state.freegameState.featureJustFinished,
        actionResult: state.gameactionstate.result,
        freegameSpinCount: state.freegameState.freegameSpinCount,
        freegameSpinCountWin: state.freegameState.freegameSpinCountWin,
        storeMultiplierCurrentValue: state.MultiplierState.storeMultiplierCurrentValue,
        totalCreditWinAmount: state.behaviourState.totalCreditWinAmount,
        fgSpinWinAmount: state.behaviourState.fgSpinWinAmount,
        blastStart: state.reelgridState.blastStart,
        freegameSpinCountRemaining: state.freegameState.freegameSpinCountRemaining,
        allSpinComplete: state.reelgridState.allSpinComplete,
        winAmount: state.basegameState.winAmount,
        callFlowManager: state.flowManagerState.callFlowManager,
        showWinShower: state.winShowerState.showWinShower,
        showWinCelebration: state.winCelebrationState.showWinCelebration,
        clickToEnterFeature: state.wrapperState.clickToEnterFeature,
        inFreeGame: state.freegameState.inFreeGame,
        totalCascadeCount: state.gridsState.totalCascadeCount,
        startRandomWild: state.randomWildsState.startRandomWild,
        isFeatureActive: state.randomWildsState.isFeatureActive,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationToBaseGameState: (basegamestate: boolean): any => dispatch(basegameActions.setApplicationToBaseGameState(basegamestate)),
        setApplicationLayoutObject: (layoutobjectlist: string): any => dispatch(layoutsActions.setApplicationLayoutObject(layoutobjectlist)),
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
        stopSound: (soundName: any): any => dispatch(soundActions.stopSound(soundName)),
        setIntroDone: (): any => dispatch(basegameActions.setIntroDone()),
        startFreegame: (): any => dispatch(freegameActions.startFreegame()),
        stopFreegame: (): any => dispatch(freegameActions.stopFreegame()),
        nextFreegame: (): any => dispatch(freegameActions.nextFreegame()),
        flowManagerCalled: (callFlowManager: boolean): any => dispatch(flowManagerAction.flowManagerCalled(callFlowManager)),
        updateReelData: (result_reel: any): any => dispatch(reelgridAction.updateReelData(result_reel)),
        activeMultiplier: (multiplierActive: boolean): any => dispatch(multiplierActions.activeMultiplier(multiplierActive)),
        setMultiplierValue: (multiplierCurrentValue: any): any => dispatch(multiplierActions.setMultiplierValue(multiplierCurrentValue)),
        setOutroBannerSkip: (value: any): any => dispatch(behaviorActions.setOutroBannerSkip(value)),
        relGridSymbolCountDisplay: (displayReelGridSymbolCount: any): any => dispatch(reelgridAction.relGridSymbolCountDisplay(displayReelGridSymbolCount)),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        nextAutoplay: (): any => dispatch(basegameActions.nextAutoplay()),
        spaceBarSpin: (spinWithSpaceBar: boolean): any => dispatch(keyboardListenerActions.spaceBarSpin(spinWithSpaceBar)),


    }))(withBannerConfiguration(GameBanner)));